const SET_COMPANY = "SET_COMPANY";
const CLEAR_COMPANY = "LOGOUT_USER";

const initialState = {
  company: null,
};

export const Company=(state = initialState, action)=> {
  switch (action.type) {
    case SET_COMPANY:
      return {
        ...state,
        company: action.payload,
      };

    case CLEAR_COMPANY:
      return {
        ...state,
        company: null,
      };

    default:
      return state;
  }
}
